/**
 * Shape renderer public API.
 * Delegates to 2D or 3D renderer based on the current view mode.
 */

import type { TakShape } from '@vtak/shared';
import type { MapInstance, ViewMode } from '../map-setup';
import { computeShapeDiff, applyShapeDiffToRegistry, clearShapeRegistry } from './shape-state';
import { initShapes2D, applyShapeDiff2D, destroyShapes2D } from './shape-2d';
import { initShapes3D, applyShapeDiff3D, destroyShapes3D } from './shape-3d';

/** Initialize the shape renderer for the given map and mode */
export function setupShapes(map: MapInstance, mode: ViewMode): void {
  if (mode === '2d') {
    initShapes2D();
  } else {
    initShapes3D();
  }
}

/** Update shapes on the map from store data */
export function updateShapes(map: MapInstance, mode: ViewMode, shapes: TakShape[]): void {
  const diff = computeShapeDiff(shapes);
  applyShapeDiffToRegistry(diff, shapes);

  if (mode === '2d') {
    applyShapeDiff2D(map as google.maps.Map, diff);
  } else {
    applyShapeDiff3D(map as google.maps.maps3d.Map3DElement, diff);
  }
}

/** Destroy all shapes and clean up */
export function destroyShapes(mode: ViewMode): void {
  clearShapeRegistry();
  if (mode === '2d') {
    destroyShapes2D();
  } else {
    destroyShapes3D();
  }
}
